module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2017-18.9b77343c.pdf";